const isNonEmptyArray = arr => arr && Array.isArray(arr) && arr.length > 0;

const isNumeric = n =>
  typeof n === 'number' && !isNaN(parseFloat(n)) && isFinite(n);

const noop = () => {};

/**
 * Path is object dot notation for path of desired data in theme
 * @param {object} obj
 * @param {string} path
 */
const checkObjectForDataPath = (obj, path) => {
  const mappablePath = path.split('.');

  let ret = true;
  if (obj && mappablePath && mappablePath.length > 0) {
    let temp = obj;
    for (let i = 0; i < mappablePath.length; i++) {
      const val = mappablePath[i];
      if (!temp || !temp[val]) {
        ret = false;
        break;
      }
      temp = temp[val];
    }
  }
  return ret;
};

const checkBrowser = type => {
  const _checkIE = () => {
    const ua =
      window && window.navigator && window.navigator.userAgent
        ? window.navigator.userAgent
        : null;
    const isIe = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
    return isIe;
  };
  switch (type) {
    case 'ie':
      return _checkIE();
    default:
      return false;
  }
};

export default {
  noop,
  isNumeric,
  isNonEmptyArray,
  checkObjectForDataPath,
  checkBrowser
};
